import { render } from "./MainTutorialIcon1.vue?vue&type=template&id=7cf1e5ac&scoped=true&ts=true"
import script from "./MainTutorialIcon1.vue?vue&type=script&lang=ts"
export * from "./MainTutorialIcon1.vue?vue&type=script&lang=ts"

import "./MainTutorialIcon1.vue?vue&type=style&index=0&id=7cf1e5ac&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf1e5ac"]])

export default __exports__